import store from '@/store'

/**
 * Navigate to the public calendars route for a partner short id.
 *
 * @param {Function} next
 * @param {String} shortId
 * @return {void}
 */
function redirectToCalendarsHome(next, shortId) {
	next({
		name: 'public.calendar',
		params: { shortId },
		replace: true,
	})
}

/**
 * Bootstrap /:shortId/calendars/:id when opened directly.
 *
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 * @return {void}
 */
export async function ensurePublicCalendarBootstrap(to, from, next) {
	const shortId = to.params.shortId

	if (!shortId) {
		next()
		return
	}

	try {
		await store.dispatch('publicCalendar/ensureBootstrap', shortId)

		if (!store.getters['publicCalendar/hasCalendars']) {
			redirectToCalendarsHome(next, shortId)
			return
		}

		const calendarId = parseInt(to.params.id, 10)
		const calendars = store.getters['publicCalendar/calendars'] || []
		const isCalendarAvailable = calendars.some(
			calendar => calendar.id === calendarId
		)

		if (!Number.isNaN(calendarId) && !isCalendarAvailable) {
			const firstCalendarId =
				store.getters['publicCalendar/firstCalendarId']

			if (!firstCalendarId) {
				redirectToCalendarsHome(next, shortId)
				return
			}

			next({
				name: 'public.calendar.show',
				params: {
					shortId,
					id: String(firstCalendarId),
				},
				replace: true,
			})
			return
		}

		next()
	} catch {
		redirectToCalendarsHome(next, shortId)
	}
}

/**
 * Bootstrap /:shortId/calendars then redirect to the first calendar id.
 *
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 * @return {void}
 */
export async function redirectPublicCalendarToFirst(to, from, next) {
	const shortId = to.params.shortId

	if (!shortId) {
		next()
		return
	}

	try {
		await store.dispatch('publicCalendar/ensureBootstrap', shortId)

		const firstCalendarId = store.getters['publicCalendar/firstCalendarId']

		if (!firstCalendarId) {
			next()
			return
		}

		next({
			name: 'public.calendar.show',
			params: {
				shortId,
				id: String(firstCalendarId),
			},
			replace: true,
		})
	} catch {
		next()
	}
}
